/**
 * Regenliebe Warenkorb: Drawer + Warenkorb-Seite.
 * - Oeffnet den Drawer ueber [data-rl-cart-open] (Header-Icon) und nach "In den Warenkorb"
 *   (Horizon-Event shopify:cart:lines-update, action "add").
 * - Mengen, Entfernen, Notiz und Upsell-Hinzufuegen laufen ueber die Cart-AJAX-API;
 *   der Inhalt wird per Section Rendering API (sections=<id>) neu geladen.
 */
(function () {
  if (window.RLCart) return;

  var CART_EVENT = 'shopify:cart:lines-update';
  var drawer = null;
  var lastTrigger = null;
  var busy = false;
  var noteTimer = null;

  function getDrawer() {
    if (!drawer || !document.body.contains(drawer)) drawer = document.querySelector('[data-rl-cart-drawer]');
    return drawer;
  }

  function isOpen() {
    var d = getDrawer();
    return !!d && d.classList.contains('is-open');
  }

  function setExpanded(value) {
    document.querySelectorAll('[data-rl-cart-open]').forEach(function (el) {
      el.setAttribute('aria-expanded', value ? 'true' : 'false');
    });
  }

  function open() {
    var d = getDrawer();
    if (!d) {
      window.location.href = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
      return;
    }
    if (isOpen()) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('rl-cart-open');
    setExpanded(true);
    var focusTarget = d.querySelector('.rl-cart-drawer__close');
    if (focusTarget) setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, 50);
  }

  function close() {
    var d = getDrawer();
    if (!d || !isOpen()) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('rl-cart-open');
    setExpanded(false);
    if (lastTrigger && document.body.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
    lastTrigger = null;
  }

  function rootUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path;
  }

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('[data-rl-cart-body]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function setBusy(value) {
    busy = value;
    document.querySelectorAll('[data-rl-cart-drawer], .rl-cart-page, [data-rl-cart]').forEach(function (el) {
      el.classList.toggle('is-loading', value);
    });
  }

  function updateBubble(count) {
    document.querySelectorAll('[data-rl-cart-count]').forEach(function (el) {
      el.textContent = String(count);
      el.hidden = !count;
    });
    document.querySelectorAll('cart-icon').forEach(function (icon) {
      if (typeof icon.renderCartBubble === 'function') {
        icon.renderCartBubble(count);
      } else {
        var c = icon.querySelector('.cart-bubble__text-count');
        if (c) c.textContent = count < 100 ? String(count) : '';
      }
    });
  }

  /** Ersetzt den Inhalt aller Cart-Bereiche mit den gerenderten Sections. */
  function applySections(sections) {
    if (!sections) return;
    var updated = NaN;
    var focusedKey = document.activeElement && document.activeElement.closest('[data-rl-line]')
      ? document.activeElement.closest('[data-rl-line]').getAttribute('data-key')
      : null;
    document.querySelectorAll('[data-rl-cart-body]').forEach(function (body) {
      var id = body.getAttribute('data-section-id');
      if (!sections[id]) return;
      var doc = new DOMParser().parseFromString(sections[id], 'text/html');
      var fresh = doc.querySelector('[data-rl-cart-body][data-section-id="' + id + '"]');
      if (!fresh) return;
      body.innerHTML = fresh.innerHTML;
      body.setAttribute('data-rl-count', fresh.getAttribute('data-rl-count') || '0');
      updated = parseInt(fresh.getAttribute('data-rl-count'), 10);
    });
    if (!isNaN(updated)) updateBubble(updated);
    if (focusedKey) {
      var again = document.querySelector('[data-rl-line][data-key="' + focusedKey + '"] [data-rl-qty-input]');
      if (again) again.focus({ preventScroll: true });
    }
  }

  function post(url, payload) {
    return fetch(rootUrl(url), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || 'Fehler');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function sectionPayload() {
    return { sections: sectionIds().join(','), sections_url: window.location.pathname };
  }

  function showLineError(line, message) {
    var el = line && line.querySelector('[data-rl-line-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  /** Aendert eine Zeile (1-basiert) auf eine neue Menge. */
  function changeLine(lineEl, quantity) {
    if (busy) return;
    var line = parseInt(lineEl.getAttribute('data-rl-line'), 10);
    var input = lineEl.querySelector('[data-rl-qty-input]');
    var before = input ? parseInt(input.getAttribute('data-qty-before'), 10) : 0;
    setBusy(true);
    if (quantity === 0) lineEl.classList.add('is-removing');
    var payload = sectionPayload();
    payload.line = line;
    payload.quantity = quantity;
    post('cart/change.js', payload)
      .then(function (cart) {
        applySections(cart.sections);
        updateBubble(cart.item_count);
        // Wurde weniger als gewuenscht gesetzt (Bestand), Hinweis zeigen.
        var item = cart.items && cart.items[line - 1];
        if (quantity > 0 && item && item.quantity < quantity) {
          var fresh = document.querySelector('[data-rl-line="' + line + '"]');
          showLineError(fresh, 'Von diesem Artikel sind nur ' + item.quantity + ' Stück verfügbar.');
        }
        notify(cart);
      })
      .catch(function (err) {
        lineEl.classList.remove('is-removing');
        if (input) input.value = before;
        showLineError(lineEl, err.message || 'Die Menge konnte nicht geändert werden.');
      })
      .then(function () { setBusy(false); });
  }

  function addVariant(button) {
    if (busy) return;
    var id = parseInt(button.getAttribute('data-rl-add'), 10);
    setBusy(true);
    var payload = sectionPayload();
    payload.items = [{ id: id, quantity: 1 }];
    post('cart/add.js', payload)
      .then(function (res) {
        applySections(res.sections);
        return fetch(rootUrl('cart.js'), { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateBubble(cart.item_count);
        notify(cart);
      })
      .catch(function (err) {
        button.textContent = 'Nicht verfügbar';
        button.disabled = true;
        console.warn('[rl-cart] add failed', err);
      })
      .then(function () { setBusy(false); });
  }

  /** Platzhalter: Header-Bubble wird direkt ueber updateBubble() aktualisiert. */
  function notify() {}

  /** Laedt die Cart-Sections neu (z. B. nach "In den Warenkorb" durch Horizon). */
  function refresh() {
    var ids = sectionIds();
    if (!ids.length) return Promise.resolve();
    var path = window.location.pathname + '?sections=' + encodeURIComponent(ids.join(','));
    return fetch(path, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(applySections)
      .catch(function (err) { console.warn('[rl-cart] refresh failed', err); });
  }

  function saveNote(value) {
    fetch(rootUrl('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: value }),
    }).catch(function () {});
  }

  /* ---------- Events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var opener = t.closest('[data-rl-cart-open]');
    if (opener) {
      if (!getDrawer()) return; // Link-Fallback zur Warenkorb-Seite
      e.preventDefault();
      lastTrigger = opener;
      open();
      return;
    }
    if (t.closest('[data-rl-cart-close]')) {
      e.preventDefault();
      close();
      return;
    }
    var step = t.closest('[data-rl-qty-step]');
    if (step) {
      var lineEl = step.closest('[data-rl-line]');
      var input = lineEl.querySelector('[data-rl-qty-input]');
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-rl-qty-step'), 10));
      changeLine(lineEl, next);
      return;
    }
    var remove = t.closest('[data-rl-remove]');
    if (remove) {
      changeLine(remove.closest('[data-rl-line]'), 0);
      return;
    }
    var add = t.closest('[data-rl-add]');
    if (add) addVariant(add);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (t.matches('[data-rl-qty-input]')) {
      var value = Math.max(0, parseInt(t.value, 10) || 0);
      var max = parseInt(t.getAttribute('max'), 10);
      if (max && value > max) value = max;
      changeLine(t.closest('[data-rl-line]'), value);
    }
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t instanceof Element && t.matches('[data-rl-note]')) {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () { saveNote(t.value); }, 600);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') {
      close();
      return;
    }
    // Fokus-Falle: Tab bleibt im geoeffneten Drawer (aria-modal).
    if (e.key === 'Tab') {
      var focusables = Array.prototype.filter.call(
        getDrawer().querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea, summary, [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      var active = document.activeElement;
      if (!getDrawer().contains(active)) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && active === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  // Horizon "In den Warenkorb" / Quick-Add: Drawer sofort oeffnen (Ladezustand),
  // Inhalt aus der Add-Antwort uebernehmen (sections) - nur falls die fehlt, nachladen.
  document.addEventListener(CART_EVENT, function (event) {
    if (event.action !== 'add' || !getDrawer()) return;
    var modal = event.target instanceof Element ? event.target.closest('dialog:modal') : null;

    var openDrawer = function () {
      if (modal && modal.open) {
        modal.addEventListener('close', open, { once: true });
        setTimeout(function () { if (!modal.open && !isOpen()) open(); }, 400);
      } else if (!isOpen()) {
        open();
      }
    };

    var finish = function (result) {
      var detail = result && result.detail;
      if (detail && detail.didError) {
        setBusy(false);
        return;
      }
      var ids = sectionIds();
      var sections = detail && detail.sections;
      var complete = sections && ids.length && ids.every(function (id) { return sections[id]; });
      var done = complete ? Promise.resolve(applySections(sections)) : refresh();
      return done.then(function () {
        if (result && result.cart && typeof result.cart.totalQuantity === 'number') updateBubble(result.cart.totalQuantity);
        setBusy(false);
        openDrawer();
      });
    };

    // Direkt-Feedback: Drawer (ausser bei Quick-Add-Dialog) sofort mit Ladezustand oeffnen.
    if (!modal) {
      setBusy(true);
      open();
    }

    if (event.promise && event.promise.then) {
      event.promise.then(finish).catch(function () { setBusy(false); });
    } else {
      finish(null);
    }
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refresh();
  });

  /** Artikel hinzufuegen: Drawer sofort mit Ladezustand oeffnen, Inhalt kommt mit der Add-Antwort. */
  function addItems(items) {
    var hasDrawer = !!getDrawer();
    if (hasDrawer) {
      setBusy(true);
      open();
    }
    var payload = { items: items };
    var ids = sectionIds();
    if (ids.length) {
      payload.sections = ids.join(',');
      payload.sections_url = window.location.pathname;
    }
    return post('cart/add.js', payload)
      .then(function (res) {
        if (res.sections) applySections(res.sections);
        else return refresh();
      })
      .catch(function (err) {
        if (hasDrawer) close();
        throw err;
      })
      .then(function () {
        setBusy(false);
        if (!hasDrawer && !document.querySelector('.rl-cart-page, [data-rl-cart]')) window.location.href = rootUrl('cart');
      }, function (err) { setBusy(false); throw err; });
  }

  window.RLCart = { open: open, close: close, refresh: refresh, add: addItems };
})();
